import styled from 'styled-components';
import Icon from 'components/Icon';
import { red, black, border1, gray } from 'utils/style/colors';

export const MapWrapper = styled('div')`
  border: ${border1};
  margin: 1.5rem 0;
  position: relative;
  & > div:first-child {
    direction: ltr;
  }
`;

export const MapActionsWrapper = styled('div')`
  align-items: flex-end;
  bottom: 2rem;
  display: flex;
  flex-direction: column;
  position: absolute;
  right: 1rem;
`;

export const MapIconAction = styled(Icon)`
  background-color: white;
  border-radius: 0.2rem;
  border: ${border1};
  color: #828282;
  padding: 0.3rem;
  position: absolute;
  transition: color 0.3s ease;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
  -webkit-tap-highlight-color: transparent;
  :hover {
    color: ${black};
  }
  ::after {
    background-image: radial-gradient(circle, ${gray} 10%, transparent 10.01%);
    background-position: 50%;
    background-repeat: no-repeat;
    content: '';
    display: block;
    height: 100%;
    left: 0;
    opacity: 0;
    pointer-events: none;
    position: absolute;
    top: 0;
    transform: scale(10, 10);
    transition:
      transform 0.5s,
      opacity 1s;
    width: 100%;
  }
  :active {
    ::after {
      opacity: 0.4;
      transform: scale(0, 0);
      transition: 0s;
    }
  }
`;

export const MapActionItem = styled('div')`
  cursor: pointer;
  height: 2.4rem;
  position: relative;
  margin-bottom: 0.5rem;
`;

export const MapRemoveLocationItem = styled(MapActionItem)`
  margin-bottom: 1rem;
  & > ${MapIconAction} {
    color: ${red};
  }
`;
